// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Parameter Table Styles - Newly added */
.parameters-table-container {
    margin: 20px auto 20px auto; /* Reduced bottom margin from 40px to 20px */
    padding: 15px;
    background-color: #f9f9f9;
    border-radius: 10px;
    box-shadow: 0 3px 15px rgba(0, 0, 0, 0.1);
    border: 1px solid #e1e1e1;
    width: 95%; /* Increased container width */
    max-width: 1200px; /* Limit maximum width */
    margin-left: auto;
    margin-right: auto;
}

.parameters-table-title {
    font-size: 22px;
    color: #2c3e50;
    text-align: center;
    margin-top: 0px;
    margin-bottom: 5px;
    border-bottom: 2px solid #4caf50;
    padding-bottom: 3px;
    font-weight: 600;
    letter-spacing: 0.5px;
}

/* Wrapper for horizontal scroll - now only for positioning */
.parameters-table-wrapper {
    width: 100%;
    padding-bottom: 5px;
    margin: 0 auto; /* Center */
}
  
/* New horizontal table design */
.parameters-horizontal-table {
    width: 100%;
    border-collapse: collapse;
    background-color: white;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    border: 1px solid #eaeaea;
    table-layout: fixed; /* Fixed width layout */
    white-space: normal;
    font-size: 11px;
    margin: 0 auto; /* Center table */
}
  
.parameters-horizontal-table thead {
    background-color: #3498db;
    color: white;
    position: sticky;
    top: 0;
}
  
.parameters-horizontal-table th {
    padding: 7px 3px; /* Reduced horizontal padding */
    text-align: center;
    font-weight: 600;
    font-size: 13px; /* Further reduced font size */
    letter-spacing: 0;
    border-right: 1px solid rgba(255, 255, 255, 0.2);
    min-width: 60px; /* Further reduced minimum width */
    max-width: 80px; /* Reduced maximum width */
    text-transform: uppercase;
    position: relative;
    vertical-align: middle;
    height: 40px;
    word-break: break-word;
    hyphens: auto;
    overflow: hidden;
}
  
.parameters-horizontal-table th::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 2px;
    background-color: rgba(255, 255, 255, 0.3);
}
  
.parameters-horizontal-table td {
    padding: 8px 3px; /* Reduced horizontal padding */
    text-align: center;
    font-size: 15px; /* Adjusted font size - 16px was too large */
    border-right: 1px solid #eee;
    font-family: "Courier New", monospace;
    background-color: #ffffff;
    transition: background-color 0.2s;
    height: 35px;
    vertical-align: middle;
    word-break: break-word;
    overflow: hidden;
    text-overflow: ellipsis;
}
  
.parameters-horizontal-table tr:hover td {
    background-color: #f4f9fd;
}
  
.parameters-horizontal-table th:last-child,
.parameters-horizontal-table td:last-child {
    border-right: none;
}
  
/* Special styles for boolean values */
.boolean-true {
    color: #27ae60;
    font-weight: bold;
}
  
.boolean-false {
    color: #e74c3c;
}
  
/* Numeric values */
.parameters-horizontal-table td {
    position: relative;
}
  
/* Change horizontal scroll indicator text */
.parameters-table-wrapper::after {
    content: '';
    display: none;
}
  
  /* Adjust table style for printing */
@media print {
.parameters-table-container {
    margin: 15px 0;
    padding: 10px;
    box-shadow: none;
    page-break-inside: avoid;
    border: 1px solid #ddd;
    width: 100%;
}

.parameters-table-title {
    font-size: 16px;
    margin-bottom: 10px;
    border-bottom: 1px solid #4caf50;
}

.parameters-table-wrapper {
    overflow-x: visible;
    width: 100%;
    max-width: 100%;
}

.parameters-table-wrapper::after {
    display: none;
}

.parameters-horizontal-table {
    font-size: 8px;
    border: 1px solid #eee;
    box-shadow: none;
    width: 100%;
    table-layout: fixed;
    white-space: normal;
}

.parameters-horizontal-table th,
.parameters-horizontal-table td {
    padding: 4px 5px;
    font-size: 7px;
    width: auto;
    min-width: auto;
    word-break: break-word;
}

.parameters-horizontal-table th {
    height: auto;
}

.parameters-horizontal-table thead {
    background-color: #f8f8f8;
    color: #333;
}

/* Boolean value print colors */
.boolean-true {
    color: black;
    font-weight: bold;
}

.boolean-false {
    color: black;
    font-weight: normal;
}
}
  
  `, "",{"version":3,"sources":["webpack://./src/css/step8_2-showParameters.css"],"names":[],"mappings":"AAAA,yCAAyC;AACzC;IACI,2BAA2B,EAAE,4CAA4C;IACzE,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,yCAAyC;IACzC,yBAAyB;IACzB,UAAU,EAAE,8BAA8B;IAC1C,iBAAiB,EAAE,wBAAwB;IAC3C,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gCAAgC;IAChC,mBAAmB;IACnB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA,6DAA6D;AAC7D;IACI,WAAW;IACX,mBAAmB;IACnB,cAAc,EAAE,WAAW;AAC/B;;AAEA,gCAAgC;AAChC;IACI,WAAW;IACX,yBAAyB;IACzB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,yCAAyC;IACzC,yBAAyB;IACzB,mBAAmB,EAAE,uBAAuB;IAC5C,mBAAmB;IACnB,eAAe;IACf,cAAc,EAAE,iBAAiB;AACrC;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;IAChB,MAAM;AACV;;AAEA;IACI,gBAAgB,EAAE,+BAA+B;IACjD,kBAAkB;IAClB,gBAAgB;IAChB,eAAe,EAAE,8BAA8B;IAC/C,iBAAiB;IACjB,gDAAgD;IAChD,eAAe,EAAE,kCAAkC;IACnD,eAAe,EAAE,0BAA0B;IAC3C,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;IACtB,YAAY;IACZ,sBAAsB;IACtB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,WAAW;IACX,0CAA0C;AAC9C;;AAEA;IACI,gBAAgB,EAAE,+BAA+B;IACjD,kBAAkB;IAClB,eAAe,EAAE,4CAA4C;IAC7D,4BAA4B;IAC5B,qCAAqC;IACrC,yBAAyB;IACzB,iCAAiC;IACjC,YAAY;IACZ,sBAAsB;IACtB,sBAAsB;IACtB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA,sCAAsC;AACtC;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA,mBAAmB;AACnB;IACI,kBAAkB;AACtB;;AAEA,4CAA4C;AAC5C;IACI,WAAW;IACX,aAAa;AACjB;;EAEE,oCAAoC;AACtC;AACA;IACI,cAAc;IACd,aAAa;IACb,gBAAgB;IAChB,wBAAwB;IACxB,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;;IAEI,gBAAgB;IAChB,cAAc;IACd,WAAW;IACX,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA,+BAA+B;AAC/B;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;AACA","sourcesContent":["/* Parameter Table Styles - Newly added */\n.parameters-table-container {\n    margin: 20px auto 20px auto; /* Reduced bottom margin from 40px to 20px */\n    padding: 15px;\n    background-color: #f9f9f9;\n    border-radius: 10px;\n    box-shadow: 0 3px 15px rgba(0, 0, 0, 0.1);\n    border: 1px solid #e1e1e1;\n    width: 95%; /* Increased container width */\n    max-width: 1200px; /* Limit maximum width */\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.parameters-table-title {\n    font-size: 22px;\n    color: #2c3e50;\n    text-align: center;\n    margin-top: 0px;\n    margin-bottom: 5px;\n    border-bottom: 2px solid #4caf50;\n    padding-bottom: 3px;\n    font-weight: 600;\n    letter-spacing: 0.5px;\n}\n\n/* Wrapper for horizontal scroll - now only for positioning */\n.parameters-table-wrapper {\n    width: 100%;\n    padding-bottom: 5px;\n    margin: 0 auto; /* Center */\n}\n  \n/* New horizontal table design */\n.parameters-horizontal-table {\n    width: 100%;\n    border-collapse: collapse;\n    background-color: white;\n    border-radius: 8px;\n    overflow: hidden;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n    border: 1px solid #eaeaea;\n    table-layout: fixed; /* Fixed width layout */\n    white-space: normal;\n    font-size: 11px;\n    margin: 0 auto; /* Center table */\n}\n  \n.parameters-horizontal-table thead {\n    background-color: #3498db;\n    color: white;\n    position: sticky;\n    top: 0;\n}\n  \n.parameters-horizontal-table th {\n    padding: 7px 3px; /* Reduced horizontal padding */\n    text-align: center;\n    font-weight: 600;\n    font-size: 13px; /* Further reduced font size */\n    letter-spacing: 0;\n    border-right: 1px solid rgba(255, 255, 255, 0.2);\n    min-width: 60px; /* Further reduced minimum width */\n    max-width: 80px; /* Reduced maximum width */\n    text-transform: uppercase;\n    position: relative;\n    vertical-align: middle;\n    height: 40px;\n    word-break: break-word;\n    hyphens: auto;\n    overflow: hidden;\n}\n  \n.parameters-horizontal-table th::after {\n    content: '';\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 2px;\n    background-color: rgba(255, 255, 255, 0.3);\n}\n  \n.parameters-horizontal-table td {\n    padding: 8px 3px; /* Reduced horizontal padding */\n    text-align: center;\n    font-size: 15px; /* Adjusted font size - 16px was too large */\n    border-right: 1px solid #eee;\n    font-family: \"Courier New\", monospace;\n    background-color: #ffffff;\n    transition: background-color 0.2s;\n    height: 35px;\n    vertical-align: middle;\n    word-break: break-word;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n  \n.parameters-horizontal-table tr:hover td {\n    background-color: #f4f9fd;\n}\n  \n.parameters-horizontal-table th:last-child,\n.parameters-horizontal-table td:last-child {\n    border-right: none;\n}\n  \n/* Special styles for boolean values */\n.boolean-true {\n    color: #27ae60;\n    font-weight: bold;\n}\n  \n.boolean-false {\n    color: #e74c3c;\n}\n  \n/* Numeric values */\n.parameters-horizontal-table td {\n    position: relative;\n}\n  \n/* Change horizontal scroll indicator text */\n.parameters-table-wrapper::after {\n    content: '';\n    display: none;\n}\n  \n  /* Adjust table style for printing */\n@media print {\n.parameters-table-container {\n    margin: 15px 0;\n    padding: 10px;\n    box-shadow: none;\n    page-break-inside: avoid;\n    border: 1px solid #ddd;\n    width: 100%;\n}\n\n.parameters-table-title {\n    font-size: 16px;\n    margin-bottom: 10px;\n    border-bottom: 1px solid #4caf50;\n}\n\n.parameters-table-wrapper {\n    overflow-x: visible;\n    width: 100%;\n    max-width: 100%;\n}\n\n.parameters-table-wrapper::after {\n    display: none;\n}\n\n.parameters-horizontal-table {\n    font-size: 8px;\n    border: 1px solid #eee;\n    box-shadow: none;\n    width: 100%;\n    table-layout: fixed;\n    white-space: normal;\n}\n\n.parameters-horizontal-table th,\n.parameters-horizontal-table td {\n    padding: 4px 5px;\n    font-size: 7px;\n    width: auto;\n    min-width: auto;\n    word-break: break-word;\n}\n\n.parameters-horizontal-table th {\n    height: auto;\n}\n\n.parameters-horizontal-table thead {\n    background-color: #f8f8f8;\n    color: #333;\n}\n\n/* Boolean value print colors */\n.boolean-true {\n    color: black;\n    font-weight: bold;\n}\n\n.boolean-false {\n    color: black;\n    font-weight: normal;\n}\n}\n  \n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
